/**
 * Stable error code thrown by `AppointmentsService` when a create or
 * reschedule request targets an instant that is not strictly in the future
 * (BR-APPOINTMENT-02). `APPOINTMENT_ERROR_I18N` is the single source that
 * maps the code to its i18n key, following the same error-code -> i18n
 * pattern already established by `PROSPECT_ERROR_I18N`,
 * `IMPERSONATION_ERROR_I18N` and `MCP_ACCESS_ERROR_I18N`.
 */
export const APPOINTMENT_ERROR_CODE = {
  DATE_NOT_IN_FUTURE: 'APPOINTMENT_DATE_NOT_IN_FUTURE',
} as const;

export type AppointmentErrorCode = (typeof APPOINTMENT_ERROR_CODE)[keyof typeof APPOINTMENT_ERROR_CODE];

export const APPOINTMENT_ERROR_I18N: Record<AppointmentErrorCode, string> = {
  [APPOINTMENT_ERROR_CODE.DATE_NOT_IN_FUTURE]: 'errors.appointmentDateNotInFuture',
};
